import {
  $authorsTableFilters,
  $authorsTablePage,
  $authorsTablePageSize,
  $authorsTableSearch,
  $authorsTableSort,
  type AuthorsSortState,
} from '@/entities/authors'
import { type GetApiAuthorsQueryParams } from '@/shared/api'
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '@/shared/lib/query'
import { createStore, sample } from 'effector'
import { createGate } from 'effector-react'

// Gate
export const AuthorsListPageGate = createGate()

// Last state

// Filters
export const $authorsListPageLatestFilters =
  createStore<GetApiAuthorsQueryParams>({})
// Sort
export const $authorsListPageLatestSort = createStore<AuthorsSortState>({
  field: null,
  order: null,
})
// Page
export const $authorsListPageLatestPage = createStore<number>(DEFAULT_PAGE)
// Page size
export const $authorsListPageLatestPageSize =
  createStore<number>(DEFAULT_PAGE_SIZE)
// Search
export const $authorsListPageLatestSearch = createStore<string>('')

sample({
  source: $authorsTableFilters,
  clock: AuthorsListPageGate.close,
  target: $authorsListPageLatestFilters,
})

sample({
  source: $authorsTableSort,
  clock: AuthorsListPageGate.close,
  target: $authorsListPageLatestSort,
})

sample({
  source: $authorsTablePage,
  clock: AuthorsListPageGate.close,
  target: $authorsListPageLatestPage,
})

sample({
  clock: AuthorsListPageGate.close,
  source: $authorsTablePageSize,
  target: $authorsListPageLatestPageSize,
})

sample({
  clock: AuthorsListPageGate.close,
  source: $authorsTableSearch,
  fn: (search) => search || '',
  target: $authorsListPageLatestSearch,
})
